import { Policy, RuleModel } from '../../../../types';
import GeneralDialog from '../../../shared/general-dialog';
import { useQuery } from '@tanstack/react-query';
import { getAllRunLogActions, RulesKeys } from '../../../api/rules-engine-api';
import RulesEngineActionLogsGrid from './rules-engine-action-logs-grid';
import dayjs from 'dayjs';
import Box from '@mui/material/Box';

interface RulesEngineAllActionLogsDialogProps {
  open: boolean;
  handleClose: () => void;
  policies: Policy[];
  rules: RuleModel[];
}

export default function RulesEngineAllActionLogsDialog({
  open,
  handleClose,
  policies,
  rules,
}: RulesEngineAllActionLogsDialogProps) {
  const last30Days = dayjs().subtract(30, 'day').startOf('day').valueOf();

  const { isLoading, data, isFetching } = useQuery({
    queryKey: [RulesKeys.RunLogActions, last30Days],
    queryFn: () => getAllRunLogActions(last30Days),
    meta: {
      errorMessage:
        'There was an issue loading logs data. Please refresh and try again.',
    },
  });

  return (
    <GeneralDialog
      maxWidth="xl"
      open={open}
      handleClose={handleClose}
      title={`Action Logs`}
      dialogContent={
        <Box sx={{ px: 2 }}>
          <RulesEngineActionLogsGrid
            data={data || []}
            isLoading={isLoading || isFetching}
            policies={policies}
            rules={rules}
          />
        </Box>
      }
    />
  );
}
